import { Provider } from '@angular/core';

import { PROTECTED_CONTROLS_CONTEXT, ProtectedControlsContext } from './protected-controls.context';
import { ProtectedControlsService } from './protected-controls.service';

export function providersForControlsContext(useValue: string): Provider[] {
  return [
    {
      provide: PROTECTED_CONTROLS_CONTEXT,
      useValue: useValue,
      multi: true,
    },
    ProtectedControlsContext,
  ];
}

export const protectedControlsRootProviders = () => [
  ProtectedControlsService,
  providersForControlsContext('app'),
];
